module.exports = __webpack_public_path__ + "assets/img/card.webp?071ed31137e80c4cae0eb118968503b3";